import { AnonymousStudentErrorType } from "../../../../anonymous-student-interfaces/enumerations/error-type";
import { StudentAPIBaseError } from "./student-api-base-error";

export class StudentAPISessionNotFoundError extends StudentAPIBaseError {
	constructor(message: string = AnonymousStudentErrorType.SESSION_NOT_FOUND_ERROR) {
		super(message);
		this.name = AnonymousStudentErrorType.SESSION_NOT_FOUND_ERROR;
	}
}
